// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/date/dateParser.js#1 $
'use strict'; 

angular.module('tc.dateParser', [])

.service('dateParser', function($locale, orderByFilter, GlobalService, tcConstants) {

	var configuration = {
		maxAdditionDays: '',
		centuryWindow: 25,
		format: 'DMY',
		formatSymbol: '',
		monthSymbol: 'M',
		separator: '/',
		todaySymbol: 'T',
		weekSymbol: 'W',
		yearSymbol: 'Y',
	};
	var globalStrings = GlobalService.getGlobalStrings();
	var monthsArray = (angular.isDefined(globalStrings.XMONTHSSHORT) ? globalStrings.XMONTHSSHORT.split(',') : []);
	var monthsArrayUpper = monthsArray.map(function(month) {
		return month.toUpperCase();
	});
	var minYear = 1841;
	var maxYear = 9999;
	var isValidYear = function(year) {
		return ((year >= minYear) && (year <= maxYear));
	};

	// Get date parsing configuration from Global Service
	if (angular.isDefined(GlobalService.configuration.date)) {
		configuration = GlobalService.configuration.date;
	}

	this.parse = function(dt) {
		var secondsInDay = 86400000;
		var re,firstChar,lastChar,jsDate;

		re = /^(\s)+/;
		dt = dt.replace(re, '');
		re = /(\s)+$/;
		dt = dt.replace(re, '');
		re = /(\s){2,}/g;
		dt = dt.replace(re, ' ');
		if (dt == '') return '';
		
		if ((configuration.format === 'HIJRA') || (configuration.format === 'THAI')) {
			if ((dt.charAt(0).toUpperCase() === configuration.formatSymbol)
				&& (dt.charAt(1) === ' ')) {
				dt = dt.replace(/ /, '');
			}
			dt = dt.split(' [')[0];
		}
		firstChar = dt.charAt(0);
		lastChar = dt.charAt(dt.length - 1);

		// If we have both last characters non numeric, it's probably DDMMMYY format 
		// So it should be parsed as Absolute date
		if (isNaN(parseInt(dt.charAt(dt.length - 2))) && isNaN(parseInt(lastChar))) lastChar = '0';

		// If first and last characters are digits, this is an absolute date, else -- relative.
		if ((!isNaN(parseInt(firstChar)) && (!isNaN(parseInt(lastChar)))) || 
			((configuration.formatSymbol !== '') && (firstChar.toUpperCase() == configuration.formatSymbol))
		) {
			jsDate = this.parseAbsoluteDate(dt);
		} else {
			jsDate = this.parseRelativeDate(dt);
		}

		if ((jsDate == null) || (isNaN(jsDate))) return '';

		if (configuration.maxAdditionalDays 
			&& Math.round((jsDate - new Date()) / (secondsInDay)) > configuration.maxAdditionalDays) {
			return '';
		}
		
		if (!isValidYear(jsDate.getFullYear())) return '';

		return this.prettyDate(jsDate);
	};

	this.parseAbsoluteDate = function(dt) {
		var d = '';
		var m = '';
		var y = '';
		var today = new Date;
		var dtArray,yearLength;
		var isGregorian = true;
		
		if (configuration.format == 'DMMMY') configuration.separator = ' ';

		var re = /[^\w]/g;
		dt = dt.replace(re, configuration.separator);

		// Thai format uses Thai dates by default
		if (configuration.format === 'THAI') {
			isGregorian = false;
			if (dt[0].toUpperCase() === configuration.formatSymbol) {
				isGregorian = true;
				dt = dt.slice(1);
			}
		} else if (configuration.format === 'HIJRA') {
			// Hijra format uses Gregorian by default
			if (dt[0].toUpperCase() === configuration.formatSymbol) {
				isGregorian = false;
				dt = dt.slice(1);
			}
		}

		if (['DMY','DMMMY','THAI','HIJRA'].indexOf(configuration.format) !== -1) {
			// if string only has more than 2 digits -- no dividers
			re = /^\d{3,}$/g;
			if (re.test(dt)) {
				d = dt.substr(0, 2);
				m = dt.substr(2, 2);
				y = dt.substr(4, 4);
			} else {
				dtArray = dt.split(configuration.separator);
				d = dtArray[0];
				m = dtArray[1];
				y = dtArray[2];
				if (m) {
					var monthsArrayIndex = monthsArrayUpper.indexOf(m.toUpperCase());
					if (monthsArrayIndex > -1) {
						m = (monthsArrayIndex + 1);
					}
				}
			}
			
			if ((configuration.format === 'HIJRA') && (!isGregorian)) {
				dtArray = this.hijraToGregorian([d,m,y]);
				d = dtArray[0];
				m = dtArray[1];
				y = dtArray[2];
			}
		} else if (configuration.format == 'MDY') {
			if (dt.search(/^\d{1,2}$/g) > -1) {
				// if string only has 1-2 digits -- it's days
				d = dt;
			} else if (dt.search(/^\d{3}$/g) > -1) {
				// if string only has 3 digits -- it's month(1digit)-days
				m = dt.substr(0, 1);
				d = dt.substr(1, 2);
			} else if (dt.search(/^\d{4,}$/g) > -1) {
				// if string only has more than 4 digits -- it's month-day-year
				m = dt.substr(0, 2);
				d = dt.substr(2, 2);
				y = dt.substr(4, 4);
			} else {
				// if we have separators
				dtArray = dt.split(configuration.separator);
				m = dtArray[0];
				d = dtArray[1];
				y = dtArray[2];
			}
		} else if (configuration.format == 'YMD') {
			if (dt.search(/^\d{1,2}$/g) > -1) {
				// if string only has 1-2 digits -- it's days
				d = dt;
			} else if (dt.search(/^\d{3}$/g) > -1) {
				// if string only has 3 digits -- it's month(1digit)-days
				m = dt.substr(0, 1);
				d = dt.substr(1, 2);
			} else if (dt.search(/^\d{4}$/g) > -1) {
				// if string only has 4 digits -- it's month(2digit)-days
				m = dt.substr(0, 2);
				d = dt.substr(2, 2);
			} else if (dt.search(/^\d{6,}$/g) > -1) {
				// if string 6+ digits -- it's year-month(2digit)-days(2digit)
				yearLength = dt.length - 4;
				y = dt.substr(0, yearLength);
				m = dt.substr(yearLength, 2);
				d = dt.substr(yearLength + 2, 2);
			} else {
				// if we have separators
				dtArray = dt.split(configuration.separator);
				y = dtArray[0];
				m = dtArray[1];
				d = dtArray[2];
			}
		}

		if (y && (y.length == 1)) y = '0' + y;

		if (y && (y.length == 2) && (configuration.format == 'THAI') && !isGregorian) {
			if (y < configuration.centuryWindow) {
				y = parseInt('25' + y, 10) - tcConstants.DATE_OPTIONS.THAI_YEAR_SHIFT;
			} else {
				y = parseInt('24' + y, 10) - tcConstants.DATE_OPTIONS.THAI_YEAR_SHIFT;
			}
		}

		if (y && (y.length == 2)) {
			if (y < configuration.centuryWindow) {
				y = '20' + y;
			} else {
				y = '19' + y;
			}
		}

		if (y && (y > 2350) && (configuration.format == 'THAI') && !isGregorian) {
			// automatic switch Thai-to-Georgian
			y = y - tcConstants.DATE_OPTIONS.THAI_YEAR_SHIFT;
		}

		// substitute current month and year by default
		m = (m ? m - 1 : today.getMonth());
		y = (y ? y : today.getFullYear());

		// check if we finally have the correct date
		var newDate = new Date(y,m,d);
		if ((newDate.getMonth() != m) || (newDate.getDate() != d) || (newDate.getFullYear() != y)) return null;

		return newDate;
	};

	this.parseRelativeDate = function(dt) {
		var found = false;
		var daysCount = 0;
		var monthsCount = 0;
		var yearsCount = 0;
		var date = new Date;
		var firstChar = dt.charAt(0).toUpperCase();
		var lastChar = dt.charAt(dt.length - 1).toUpperCase();

		// If last character is not a digit, stick it to the front converting +2w to w+2
		if (isNaN(parseInt(lastChar))) {
			firstChar = lastChar;
			dt = lastChar + dt.slice(0, dt.length - 1);
		}

		if ((firstChar == '+') || (firstChar == '-')) {
			firstChar = configuration.todaySymbol;
			if (dt.length == 1) {
				dt = configuration.todaySymbol;
			} else {
				dt = configuration.todaySymbol + dt;
			}
		}

		if (firstChar == configuration.todaySymbol) {
			found = true;
			daysCount = +dt.slice(1, dt.length);
			if (isNaN(daysCount)) return null;
		}

		if (firstChar == configuration.weekSymbol) {
			found = true;
			daysCount = 7 * dt.slice(1, dt.length);
			if (isNaN(daysCount)) return null;
		}

		if (firstChar == configuration.monthSymbol) {
			found = true;
			monthsCount = +dt.slice(1, dt.length);
			if (isNaN(monthsCount)) return null;
		}

		if (firstChar == configuration.yearSymbol) {
			found = true;
			yearsCount = +dt.slice(1, dt.length);
			if (isNaN(yearsCount)) return null;
		}

		if (!found) return null;
		
		var fullYear = (date.getFullYear() + yearsCount);
		if (!isValidYear(fullYear)) return null;
		
		date = new Date(fullYear, (date.getMonth() + monthsCount), (date.getDate() + daysCount));
		return date;
	};

	this.prettyDate = function(jsDate) {
		var d = jsDate.getDate();
		var m = jsDate.getMonth() + 1;
		var y = jsDate.getFullYear();
		var dt;

		if (configuration.format == 'DMMMY') configuration.separator = ' ';

		if (d < 10) d = '0' + d;
		if (m < 10) m = '0' + m;

		if (configuration.format == 'DMY') {
			dt = d + configuration.separator + m + configuration.separator + y;
		} else if (configuration.format == 'DMMMY') {
			dt = d + configuration.separator + monthsArray[parseInt(m, 10) - 1] + configuration.separator + y;
		} else if (configuration.format == 'MDY') {
			dt = m + configuration.separator + d + configuration.separator + y;
		} else if (configuration.format == 'YMD') {
			dt = y + configuration.separator + m + configuration.separator + d;
		} else if (configuration.format == 'THAI') {
			dt = d + configuration.separator + m + configuration.separator + 
			(parseInt(y, 10) + tcConstants.DATE_OPTIONS.THAI_YEAR_SHIFT) + ' [' + y + ']';
		} else if (configuration.format == 'HIJRA') {
			dt = (d + configuration.separator + m + configuration.separator + y);
			var dmyHijra = this.gregorianToHijra([d,m,y]);
			if (dmyHijra) {
				dt = (dt + ' [' + dmyHijra[0] + configuration.separator
				+ dmyHijra[1] + configuration.separator + dmyHijra[2] + ']');
			}
		}

		return dt;
	};

	this.toDate = function(dt) {
		// For invalid values, return the current date
		if (dt === '') return new Date();
		var d,m,y;
		var dtArray;
		if (configuration.format == 'DMMMY') configuration.separator = ' ';
		if (configuration.format === 'HIJRA') {
			dt = dt.split(' ')[0];
		}
		dtArray = dt.split(configuration.separator);
		if (configuration.format == 'THAI') {
			dtArray[2] = dtArray[2].substr(0, 4) - tcConstants.DATE_OPTIONS.THAI_YEAR_SHIFT;
		}
		if (['DMY','THAI','HIJRA'].indexOf(configuration.format) !== -1) {
			d = dtArray[0];
			m = dtArray[1];
			y = dtArray[2];
		} else if (configuration.format == 'DMMMY') {
			d = dtArray[0];
			m = monthsArrayUpper.indexOf(dtArray[1].toUpperCase()) + 1;
			y = dtArray[2];
		} else if (configuration.format == 'MDY') {
			m = dtArray[0];
			d = dtArray[1];
			y = dtArray[2];
		} else if (configuration.format == 'YMD') {
			y = dtArray[0];
			m = dtArray[1];
			d = dtArray[2];
		}
		var returnDate = new Date(y,m - 1,d);
		// if we have invalid date object, return current date
		if (isNaN(returnDate)) {
			return new Date();	
		}
		return returnDate;
	};
	
	// Converts a date array [day,month,year] from Gregorian to Hijra
	// Month should be 1-indexed
	// *** NOTE:
	// Logic is a copy of websys.Conversions:DateLogicalToHijra
	// Any changes here should also be made in that method
	// *********
	this.gregorianToHijra = function(dmyDate) {
		if ((angular.isUndefined(dmyDate)) || (!angular.isArray(dmyDate))) return null;
		
		var d = parseInt(dmyDate[0], 10);
		var m = parseInt(dmyDate[1], 10);
		var y = parseInt(dmyDate[2], 10);
		if (angular.isUndefined(d)) return null;
		if (angular.isUndefined(m)) return null;
		if (angular.isUndefined(y)) return null;
		var jd;
		
		// Check conversions from code table (User.CTDateConvHijri) and return if found
		if (angular.isDefined(configuration.hijraConversions)) {
			var dayPadded = d.toString();
			dayPadded = (dayPadded.length < 2 ? ('0' + dayPadded) : dayPadded);
			var monthPadded = m.toString();
			monthPadded = (monthPadded.length < 2 ? ('0' + monthPadded) : monthPadded);
			var gregorianDate = (dayPadded + configuration.separator + monthPadded + configuration.separator + dmyDate[2]);
			var hijraDate = configuration.hijraConversions[gregorianDate];
			if (angular.isDefined(hijraDate)) {
				return hijraDate.split(configuration.separator);
			}
		}
		
		// Otherwise use the standard algorithm
		if ((y > 1582) || ((y = 1582) && (m > 10)) || ((y = 1582) && (m = 10) && (d > 14))) {
			jd = parseInt((1461 * (y + 4800 + parseInt((m - 14) / 12))) / 4)
			+ parseInt((367 * (m - 2 - (12 * (parseInt((m - 14) / 12))))) / 12)
			- parseInt((3 * (parseInt((y + 4900 + parseInt((m - 14) / 12)) / 100))) / 4)
			+ d - 32075;
		} else {
			jd = (367 * y) - parseInt((7 * (y + 5001 + parseInt((m - 9) / 7))) / 4) + parseInt((275 * m) / 9) + d + 1729777;
		}
		var l = (jd - 1948440 + 10632);
		var n = parseInt((l - 1) / 10631);
		l = l - (10631 * n) + 354;
		var j = ((parseInt((10985 - l) / 5316)) * (parseInt((50 * l) / 17719)))
				+ ((parseInt(l / 5670)) * (parseInt((43 * l) / 15238)));
		l = l - ((parseInt((30 - j) / 15)) * (parseInt((17719 * j) / 50)))
				- ((parseInt(j / 16)) * (parseInt((15238 * j) / 43))) + 29;
		m = parseInt((24 * l) / 709);
		d = l - parseInt((709 * m) / 24);
		y = (30 * n) + j - 30;
		
		if (d < 10) d = ('0' + d);
		if (m < 10) m = ('0' + m);
		
		return [d, m, y];
	};
	
	// Converts a date array [day,month,year] from Hijra to Gregorian
	// Month should be 1-indexed
	// *** NOTE:
	// Logic is a copy of websys.Conversions:DateHijraToLogical
	// Any changes here should also be made in that method
	// *********	
	this.hijraToGregorian = function(hijraDate) {
		if ((angular.isUndefined(hijraDate)) || (!angular.isArray(hijraDate))) return null;
		
		var d = parseInt(hijraDate[0], 10);
		var m = parseInt(hijraDate[1], 10);
		var y = parseInt(hijraDate[2], 10);
		if (angular.isUndefined(d)) return null;
		if (angular.isUndefined(m)) return null;
		if (angular.isUndefined(y)) return null;
		
		// Check conversions from code table (User.CTDateConvHijri) and return if found
		if (angular.isDefined(configuration.hijraConversions)) {
			var dayPadded = d.toString();
			dayPadded = (dayPadded.length < 2 ? ('0' + dayPadded) : dayPadded);
			var monthPadded = m.toString();
			monthPadded = (monthPadded.length < 2 ? ('0' + monthPadded) : monthPadded);
			var hijraFullDate = (dayPadded + configuration.separator + monthPadded + configuration.separator + y);
			var conversionFound = null;
			
			angular.forEach(configuration.hijraConversions, function(conversionHijra, conversionGregorian) {
				if (hijraFullDate === conversionHijra) conversionFound = conversionGregorian;
			});
			if (conversionFound) return conversionFound.split(configuration.separator);
		}

		var jd,l,n,i,j,k;
		jd = (parseInt((11 * y + 3) / 30) + (354 * y) + (30 * m) - parseInt((m - 1) / 2) + d + 1948440 - 385);
		if (jd > 2299160) {
			l = jd + 68569;
			n = parseInt((4 * l) / 146097);
			l = l - parseInt(((146097 * n) + 3) / 4);
			i = parseInt((4000 * (l + 1)) / 1461001);
			l = l - parseInt((1461 * i) / 4) + 31;
			j = parseInt((80 * l) / 2447);
			d = l - parseInt((2447 * j) / 80);
			l = parseInt(j / 11);
			m = j + 2 - (12 * l);
			y = (100 * (n - 49)) + i + l;
		} else {
			j = jd + 1402;
			k = parseInt((j - 1) / 1461);
			l = j - (1461 * k);
			n = parseInt((l - 1) / 365) - parseInt(l / 1461);
			i = l - (365 * n) + 30;
			j = parseInt((80 * i) / 2447);
			d = i - parseInt((2447 * j) / 80);
			i = parseInt(j / 11);
			m = j + 2 - (12 * i);
			y = (4 * k) + n + i - 4716;
		}
		
		return [d,m,y];
	};

});
